<template>
  <div v-if="loading" class="flex h-full justify-center items-center">
    <loading-spinner diameter="64px" />
  </div>

  <alert-badge
      v-else-if="error.title"
      isDanger
      :title="error.title"
      :body="error.body"
      @dismissed="
      () => {
        error.title = ''
        error.body = ''
      }
    "
  />

  <money-collector-commission-form
      v-else
      :initCommission="initCommission"
      :successMsg="$t('actions.saveChangesSuccess')"
      :submitAction="update"
  />
</template>

<script lang="ts">
import { defineComponent, onBeforeMount, ref } from 'vue'

import { useHTTP } from '@/plugins/http'

import MoneyCollectorCommission from '@/models/hr/MoneyCollectorCommission'

// components
import LoadingSpinner from '@/components/LoadingSpinner.vue'
import MoneyCollectorCommissionForm from '@/views/hr/money-collector-commissions/MoneyCollectorCommissionForm.vue'
import AlertBadge from '@/components/AlertBadge.vue'
import { useRoute } from 'vue-router'
import {router} from '@/router'

export default defineComponent({
  name: 'money-collector-commission',
  components: {
    LoadingSpinner,
    MoneyCollectorCommissionForm,
    AlertBadge
  },

  setup() {
    const initCommission = ref(new MoneyCollectorCommission())
    const http = useHTTP()
    const loading = ref(true)
    const error = ref({ title: '', body: '' })

    const route = useRoute()

    onBeforeMount(async () => {
      const url = `${MoneyCollectorCommission.ENDPOINT}/${route.params.id}`

      try {
        const resp = await http.get<MoneyCollectorCommission>(url)
        initCommission.value = MoneyCollectorCommission.from(resp)
      } catch (errorResp: any) {
        error.value.title = errorResp.title
        error.value.body = errorResp.body
      }

      loading.value = false
    })

    const update = async (commission: MoneyCollectorCommission) => {
      try {
        const url = `${MoneyCollectorCommission.ENDPOINT}/${commission.id}`
        const resp = await http.put<MoneyCollectorCommission>(url, commission)
        initCommission.value = MoneyCollectorCommission.from(resp)
        router.back()
      } catch (error) {
        return error
      }
    }

    return {
      initCommission,
      loading,
      update,
      error
    }
  }
})
</script>
